import { sets } from 'abis/set/sets'
import Big from 'big.js'
import { fromBNValue } from 'utils'
import { ReceivedToken } from './interface'

interface DollarValueOptions {
  network: number
  isBuying: boolean
  basePrice: string
}

const getDollarValue = (
  amount: string,
  nativePrice: string,
  usdcPrice: string,
  token: string,
  options: DollarValueOptions,
): Big => {
  const { isBuying, network, basePrice } = options
  let dollarValue = Big(0)

  if (Number(amount) > 0) {
    if (isBuying) {
      dollarValue = Big(Big(basePrice).toString()).mul(amount).precision(2)
    } else {
      if (token === sets[network || 1].USDC) {
        dollarValue = Big(amount).mul(usdcPrice).precision(6)
      } else {
        dollarValue = Big(amount).mul(nativePrice).precision(2)
      }
    }
  }
  return dollarValue
}

export const accumulatedDollarValueFromTokensReceived = (
  receivedTokens: ReceivedToken[],
  basePrice: string,
  network: number,
  isBuying: boolean,
): Big => {
  const options = {
    network,
    isBuying,
    basePrice,
  }

  // loop through all tokens received and get the dollar value accumulate into one total value
  return receivedTokens.reduce((totalValue: Big, token: ReceivedToken) => {
    const currentTokenAmount = getDollarValue(
      token.outputAmount && token.outputAmount.gt(0)
        ? fromBNValue(token.outputAmount.toString(), `${token.decimals}`).toString()
        : '0',
      token.nativePrice,
      token.usdcPrice,
      token.token,
      options,
    )
    return totalValue.add(currentTokenAmount)
  }, Big(0))
}
